import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  cancelledStatus,
  isLeadAMainBooking,
  isLeadASubBooking,
} from 'utils/lead/leadUtils';
import { PropertyBusinessType } from 'models/Properties';
import LeadModalContext from './LeadModalContext';

const useLeadGroupBookingValues = () => {
  const { t } = useTranslation();
  const { lead, groupBookingLeads, setCurrentLeadUid } =
    useContext(LeadModalContext);
  const { watch } = useFormContext();
  const { uid: leadUid } = useWatch();
  const updateMode = !!leadUid;

  const currentGroupBookingLeadUid = watch('currentGroupBookingLeadUid');

  useEffect(() => {
    if (currentGroupBookingLeadUid) {
      setCurrentLeadUid(currentGroupBookingLeadUid);
    }
  }, [currentGroupBookingLeadUid]);

  const showGroupBookingSelect =
    updateMode &&
    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    (isLeadAMainBooking(lead) || isLeadASubBooking(lead)) &&
    // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    groupBookingLeads?.subLeads?.length > 0;

  const groupBookingOptions = showGroupBookingSelect
    ? [
        {
          label: t('componentLead.groupBooking.mainBooking'),
          // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          value: groupBookingLeads.mainLead.uid,
        },
        // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        ...groupBookingLeads.subLeads
          // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          .sort((a, b) => a.unit?.name.localeCompare(b.unit?.name))
          .map((l) => ({
            label:
              cancelledStatus.includes(l.status) ||
              l.property?.businessType === PropertyBusinessType.SUB_UNIT
                ? l.property?.name
                : l.unit?.name,
            value: l.uid,
            disabled: cancelledStatus.includes(l.status),
          })),
      ]
    : [];

  return {
    showGroupBookingSelect,
    groupBookingOptions,
  };
};

export default useLeadGroupBookingValues;
